import toast from "react-hot-toast";
import { AuthContextType } from "../StateManagement/authContext";

export interface ICloseDialog {
    handleCloseDialog: () => void; // Define handleCloseDialog prop
  }

//auth helper;
let authContext: AuthContextType | null = null;

export const setAuthContext = (ctx: AuthContextType) => {
  authContext = ctx;
};

let hasHandledAuthFailure = false;

export const handleAuthFailure = () => {
  if (hasHandledAuthFailure) return;
  hasHandledAuthFailure = true;

  if (authContext) {
    authContext.setIsAuthenticated(false);
    authContext.setUser(null);
  }

  // toast.error('Session expired. Please log in again.');
  // window.location.href = '/login';
};

